// src/pages/AuthCallback.jsx
import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleOAuthCallback } = useAuth();
  const token = searchParams.get("token");
  const processingRef = useRef(false);

  useEffect(() => {
    if (processingRef.current) return;

    if (token) {
      processingRef.current = true;
      
      const processToken = async () => {
        const result = await handleOAuthCallback(token);
        if (result.success) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate(`/login?error=oauth_failed&message=${encodeURIComponent(result.error || "Verification failed")}`, { replace: true });
        }
      };
      
      processToken();
    } else {
      navigate("/login?error=oauth_failed", { replace: true });
    }
  }, [token, navigate, handleOAuthCallback]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: "grey.900",
        color: "white",
      }}
    >
      <CircularProgress sx={{ color: "#a855f7", mb: 2 }} />
      <Typography>Completing authentication...</Typography>
    </Box>
  );
}











